import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgWhatsappFill = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
   viewBox='0 0 16 16'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d="M12.9031 3.03437C11.5937 1.72187 9.85 1 7.99687 1C4.17187 1 1.05937 4.1125 1.05937 7.93747C1.05937 9.1594 1.37812 10.3531 1.98437 11.4063L1 15L4.67813 14.0344C5.69063 14.5875 6.83125 14.8781 7.99373 14.8781H7.99687C11.8187 14.8781 15 11.7656 15 7.9406C15 6.0875 14.2125 4.34687 12.9031 3.03437ZM7.99687 13.7094C6.95937 13.7094 5.94375 13.4313 5.05937 12.9063L4.85 12.7813L2.66875 13.3531L3.25 11.225L3.1125 11.0063C2.53437 10.0875 2.23125 9.02813 2.23125 7.93753C2.23125 4.75937 4.81875 2.17187 8 2.17187C9.5406 2.17187 10.9875 2.77187 12.075 3.8625C13.1625 4.95313 13.8313 6.4 13.8281 7.9406C13.8281 11.1219 11.175 13.7094 7.99687 13.7094ZM11.1594 9.3906C10.9875 9.30313 10.1344 8.8844 9.975 8.82813C9.8156 8.76873 9.7 8.7406 9.5844 8.9156C9.46873 9.0906 9.13747 9.47813 9.0344 9.59687C8.9344 9.71247 8.83127 9.72813 8.6594 9.6406C7.64063 9.13127 6.97187 8.73127 6.3 7.57813C6.12187 7.27187 6.47813 7.29375 6.80937 6.63125C6.86563 6.51563 6.8375 6.41563 6.79375 6.32813C6.75 6.24063 6.40313 5.3875 6.25937 5.04063C6.11875 4.70313 5.975 4.75 5.86875 4.74375C5.76875 4.7375 5.65313 4.7375 5.5375 4.7375C5.42187 4.7375 5.23437 4.78125 5.075 4.95313C4.91563 5.12813 4.46875 5.54687 4.46875 6.4C4.46875 7.25313 5.09063 8.07813 5.175 8.19373C5.2625 8.3094 6.39687 10.0594 8.13747 10.8125C9.23747 11.2875 9.66873 11.3281 10.2187 11.2469C10.5531 11.1969 11.2437 10.8281 11.3875 10.4219C11.5313 10.0156 11.5313 9.66873 11.4875 9.59687C11.4469 9.51873 11.3313 9.475 11.1594 9.3906Z"
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgWhatsappFill)
export default ForwardRef
